import { Component, Input } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-waiting-module-scoped',
  animations: [
    trigger('waitingAnimation', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('500ms', style({ opacity: '1' })),
      ]),
      transition(':leave', [
        style({ opacity: '1' }),
        animate('500ms', style({ opacity: '0' })),
      ]),
    ]),
  ],
  templateUrl: './waitingModuleScoped.component.html',
  styleUrls: ['./waitingModuleScoped.component.scss'],
})
export class WaitingModuleScopedComponent {
  @Input() localSpinner: boolean;
  @Input() noBackdrop: boolean;
  @Input() excludeSpinner?: boolean = false;
  @Input() isGlobalSpinner: boolean = false;
}
